import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { labelTranslationKeyToFromToLabel, labelTranslationKeyToString } from '../../helpers';
import { SearchParam, SearchParamType } from '../../search-param.model';
import { FILTER_PER_ROW } from '../settings';

@Component({
    selector: 'se-ap-filters-row',
    templateUrl: './ap-filters-row.component.html',
    styleUrls: ['./ap-filters-row.component.scss'],
    standalone: false,
})
export class ApFiltersRowComponent implements OnInit, OnDestroy {
    filterWidth: string = '';
    protected readonly SearchParamType = SearchParamType;

    labelTranslationKeyToString = labelTranslationKeyToString;

    labelTranslationKeyToFromToLabel = labelTranslationKeyToFromToLabel;

    private destroyed$ = new Subject<void>();

    @Input() rowSize$: BehaviorSubject<number> | null = null;

    @Input() searchParams: SearchParam[] = [];

    @Output()
    filterChanged = new EventEmitter<{ name: string; idx: number }>();

    @Output()
    resetComboValue = new EventEmitter<{ name: string; idx: number }>();

    @Output()
    doSearch: EventEmitter<void> = new EventEmitter();

    @Input()
    onFromToErrorChange: ($event: any) => void = () => {};

    onEnterKeyDown(e: Event) {
        e.preventDefault();
        this.doSearch.emit();
    }

    onFilterChange(name: string, idx: number) {
        /*chiamato anche da se-from-to su due output differenti per mantenere la retrocompatibilita del componente <se-from-to>*/
        this.filterChanged.emit({ name, idx });
    }

    resetComboSelectedValue(filterName: string, idx: number, $event: MouseEvent) {
        $event.stopPropagation();
        this.resetComboValue.emit({ name: filterName, idx });
    }

    ngOnInit() {
        this.rowSize$?.pipe(takeUntil(this.destroyed$)).subscribe((size) => {
            setTimeout(() => (this.filterWidth = (size - 2 - 16 * FILTER_PER_ROW) / FILTER_PER_ROW + 'px'));
        });
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    onSearchEnter() {
        this.doSearch.emit();
    }

    onLocalFilter(param: SearchParam, searchValue: string) {
        const data = param.property.itemsSourceInfo;
        if (!data) return;

        if (!data.originalData) {
            data.originalData = [...(data.data ?? [])];
        }

        if (!searchValue || !searchValue.trim()) {
            data.data = [...data.originalData];
            return;
        }

        const displayProp = data.displayProperty ?? '';
        const lowerSearch = searchValue.toLowerCase();

        data.data = data.originalData.filter((opt: any) =>
            String(opt[displayProp] ?? '')
                .toLowerCase()
                .includes(lowerSearch),
        );
    }

    getSelectedOptionsTooltip(param: any): string {
        if (!param.property.value || param.property.value.length === 0) {
            return '';
        }

        const items = param.property.itemsSourceInfo?.data ?? [];
        const selectedItems = items.filter((item: any) => param.property.value.includes(item.guid ?? item.id));

        return selectedItems.map((item: any) => item[param.property.itemsSourceInfo?.displayProperty ?? '']).join(', ');
    }
}
